import { render, staticRenderFns } from "./FIBLoader.vue?vue&type=template&id=3c622553&scoped=true&"
import script from "./FIBLoader.vue?vue&type=script&lang=js&"
export * from "./FIBLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c622553",
  null
  
)

export default component.exports